import { isSSR } from 'utils';

export const isStaging = (): boolean | undefined => {
  if (!isSSR) {
    return window.location.hostname === 'staging';
  }
};
